// extracted by mini-css-extract-plugin
export default {"mask":"preloader_mask__3k9rl","loader":"preloader_loader__E3-JO"};